import { Loader } from '@googlemaps/js-api-loader';
import { Merchant } from '../types';

export function useMap() {

    let map: google.maps.Map;

    async function setMapCenter(merchant: Merchant): Promise<void> {
        const service = new google.maps.places.PlacesService(map);
        const request = {
            query: merchant.businessName + ', ' + merchant.address.street1 + ', ' + merchant.address.city + ' ' + merchant.address.postalCode,
            fields: ['name', 'geometry'],
        };

        service.findPlaceFromQuery(request, function(results, status) {
            if(status === google.maps.places.PlacesServiceStatus.OK) {
                map.setCenter(results[0].geometry.location);
                new google.maps.Marker({
                    position: results[0].geometry.location,
                    map: map,
                });
            }
            return;
        });
    }

    function loadMap(merchant: Merchant) {
        const loader = new Loader({
            apiKey: 'AIzaSyDWEz75RxQWS7I7SX2gYCEMkXpe7VBS_g0',
            version: 'weekly',
            libraries: ['places'],
        });

        const mapOptions = {
            center: {
                lat: 0,
                lng: 0,
            },
            zoom: 16,
            disableDefaultUI: true,
        };

        loader.load()
            .then(async (google) => {
                map = new google.maps.Map(document.getElementById('map'), mapOptions);
                await setMapCenter(merchant);
            })
            .catch(e => {
                console.error(e);
            });
    }

    function redirectToDirections(lat: number, long: number, destination: string, businessName: string): void {
        const destinationEncoded = encodeURIComponent(businessName + ', ' + destination);
        const mapUrl = `https://www.google.com/maps/dir/?api=1&origin=${lat},${long}&destination=${destinationEncoded}`;
        window.open(mapUrl, '_blank').focus();
    }

    return {
        loadMap,
        redirectToDirections,
    };
}
